const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate allEmployeesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const excluding = await evaluateSource(source.excluding, content, parentContentPath, transientContext, nativeFunctions);
  const filterText = transientContext.filterText;
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'User',
    properties: ['id', 'firstName', 'lastName', 'employeeNumber'],
    equals: {
      active: 1
    },
    equalsNoneOf: {
      id: excluding
    },
    contains: {
      lastName: filterText
    }
  };
  const users = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  users.forEach(user => {
    result[user.id] = {
      title: "".concat(user.firstName, " ").concat(user.lastName),
      _created: "".concat(user.lastName, " ").concat(user.firstName),
      employeeNumber: user.employeeNumber
    };
  });
  return result;
};
module.exports = {
  evaluate
};